/* eslint-disable */

import { useEffect, useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SelectPicker } from 'rsuite';
import {
	getUnitConvertedQuantity,
	getUnitConvertedUnit,
} from '../../../Helpers/utils';
import assetServices from '../../../Services/AssetServices/asset.services';
import { analyticsAction, formActions } from '../../../Actions';
import { Warehouse, Store } from 'lucide-react';
import StoreStockCard from './StoreStockCard';
import { Tooltip } from '@mui/material';
import { BarChart3, Table } from 'lucide-react';
import inventoryAnalysisIcon from '../../../Images/inventoryAnalysis.png';
import { urls } from '../../../Constants';

const DisplayStoreView = ({ selectedStore, selectedDate, refresh, viewTypeProcess = false }) => {
	const dispatch = useDispatch();
	const [assetsList, setAssetsList] = useState([]);
	const [assetsLoading, setAssetsLoading] = useState(false);
	const [selectedCategory, setSelectedCategory] = useState(null);

	// Get stock data from Redux
	const stockData = useSelector(
		(state) => state.analytics.INVENTORY_ANALYTICS.SKU_STOCK
	);

	const allProducts = useSelector(
		(state) => state.form.ALL_PRODUCTS.data.LIST
	);

	useEffect(() => {
		dispatch(
			formActions.gateway({
				entity: 'ALL_PRODUCTS',
				req: {
					params: {
						id: '',
						skuType: '',
						combo: true,
						variants: true,
					},
				},
				method: 'LIST',
			})
		);
	}, []);

	// Fetch Assets
	useEffect(() => {
		const fetchAssets = async () => {
			if (!selectedStore) return;
			setAssetsLoading(true);
			try {
				const reqPayload = {
					storeId: selectedStore,
					type: 'Display Freezer'
				}
				if (viewTypeProcess) {
					const result = await assetServices.processProductInventoryService(
						{
							req: {
								data: reqPayload,
							},
						}
					);
					if (result?.status === 'Success' && result?.data?.process) {
						setAssetsList(result.data.process);
					}
				} else {
					const result = await assetServices.assetProductInventoryService(
						{
							req: {
								data: reqPayload,
							},
						}
					);
					if (result?.status === 'Success' && result?.data?.assets) {
						setAssetsList(result.data.assets);
					}
				}
			} catch (error) {
				console.error('Error fetching assets:', error);
			} finally {
				setAssetsLoading(false);
			}
		};
		fetchAssets();
	}, [selectedStore, refresh]);

	// Fetch Stock Data
	useEffect(() => {
		if (!selectedStore) return;
		const req = {
			params: {
				type: 'stock', // Assuming 'stock' tab equivalent
				storeId: selectedStore,
			},
		};
		dispatch(
			analyticsAction.gateway({
				entity: 'INVENTORY_ANALYTICS',
				req,
				method: 'SKU_STOCK',
			})
		);
	}, [selectedStore, dispatch, refresh]);

	// Group Stock by Asset
	const stockRx = useMemo(() => {
		if (!stockData || !assetsList.length) return {};

		const grouped = {};
		// Initialize assets in grouped object

		const productsMap = new Map();
		const variantsMap = new Map();

		if (Array.isArray(allProducts)) {
			allProducts?.forEach((p) => {
				productsMap?.set(p?.id, p);
				if (Array.isArray(p?.variants)) {
					p?.variants?.forEach((v) => {
						variantsMap.set(v.id, {
							...v,
							productName: p.productName,
							productImages: p.productImages || p.productImageUrl,
							parentProduct: p,
							categoryName: p.categoryName,
							categoryId: p.categoryId,
						});
					});
				}
			});
		}

		const getProductInfo = (productId, variantId) => {
			const info = {};
			// Try match variant first if variantId exists
			if (variantId && variantsMap.has(variantId)) {
				const v = variantsMap.get(variantId);
				info.productName = v.productName;
				info.variantName = v.displayName;
				info.productImages = v.productImages;
				info.skuName = v.productName;
				info.unit = v.parentProduct?.unit || v.unit || '';
				info.categoryName = v.categoryName;
				info.categoryId = v.categoryId;
			} else if (productId && productsMap.has(productId)) {
				const p = productsMap.get(productId);
				info.productName = p.productName;
				info.productImages = p.productImages || p.productImageUrl;
				info.skuName = p.productName;
				info.unit = p.unit || '';
				info.categoryName = p.categoryName;
				info.categoryId = p.categoryId;
				// Try to guess variant if only 1?
				if (p.variants?.length === 1) {
					const v = p.variants[0];
					info.variantName = v.displayName;
					info.skuName = p.productName;
				}
			}
			return info;
		};

		console.log(assetsList, 'assetsListpppppppppppppppp');
		assetsList.forEach((asset) => {
			if (!grouped[asset.id]) grouped[asset.id] = [];
			const stocks = asset.stock ?? [];
			grouped[asset.id] = stocks
				.map((s) => {
					const productId = s.productId || s.id;
					const variantId = s.variantId;
					const info = getProductInfo(productId, variantId);
					let productImages =
						info.productImages ||
						s.productImages ||
						s.productImageUrl;
					if (typeof productImages === 'string')
						productImages = [productImages];

					const currentStock = s.stock || 0;
					const maxStock = s.maxStock ?? currentStock;

					const qtyVal = getUnitConvertedQuantity(
						currentStock,
						info.unit
					);
					const qtyUnit = getUnitConvertedUnit(
						currentStock,
						info.unit
					);

					const maxQtyVal = getUnitConvertedQuantity(
						maxStock,
						info.unit
					);
					const maxQtyUnit = getUnitConvertedUnit(
						maxStock,
						info.unit
					);

					const stockDetails = {
						qty: `${qtyVal} ${qtyUnit}`,
						maxStock: `${maxQtyVal} ${maxQtyUnit}`,
						expiryDate: s.expDate,
					};

					return {
						...s,
						...info,
						productImages,
						stockDetails,
					};
				})
				.filter((item) => {
					if (!selectedCategory) return true;
					return item.categoryId === selectedCategory;
				});
			// console.log(grouped[asset.id], 'asset.stock');
		});

		// Add 'Store Inventory' or unassigned if needed?
		// The image shows "Store Inventory", "FDU#1", "FDU#2"...
		// "Store Inventory" might be items not in any specific asset or a specific asset?
		// For now let's stick to assets returned by API.

		const dataArray = Array.isArray(stockData) ? stockData : [];

		dataArray.forEach((item) => {
			// Filter by category if selected
			const product = productsMap.get(item.id);
			const categoryId = product?.categoryId || item.categoryId;

			if (selectedCategory && categoryId !== selectedCategory) return;

			item.currentStock?.forEach((stock) => {
				const productId = item.id;
				// Attempt to find variantId from stock or matching
				let variantId = stock.variantId;

				// Extra logic: if stock doesn't have variantId but item has variants matching stock?
				// Assuming stock has variantId or we fallback to product
				// If stock.variantId is missing, check if item.variants has one variant?

				const info = getProductInfo(productId, variantId);

				let productImages =
					info.productImages ||
					item.productImages ||
					item.productImageUrl;
				if (typeof productImages === 'string')
					productImages = [productImages];
				// const assetId = stock.assetId; // Assuming stock object has assetId
				// if (grouped[assetId]) {
				// 	grouped[assetId].push({
				// 		...item,
				// 		stockDetails: stock,
				// 	});
				// } else if (!assetId) {
				// Handle unassigned?
				if (!grouped['store']) grouped['store'] = [];
				console.log(stock, 'stockStore');
				const maxStockData = Array.isArray(item.maxStock)
					? item.maxStock.find((ms) => ms.variantId === variantId)
					: null;

				const stockDetails = {
					qty: `${stock.qty}`,
					rawQty: stock.rawQty,
					maxStock:
						maxStockData && maxStockData.qty?.split(' ')[0] > 0
							? maxStockData.qty
							: stock.qty,
					expiryDate: stock.expDate,
				};
				grouped['store'].push({
					...item,
					...info,
					productImages,
					stockDetails,
				});
				// }
			});
		});

		return grouped;
	}, [stockData, assetsList, selectedCategory, allProducts]);

	console.log(stockRx, 'pppppppppRx');

	// Prepare node data for ModernNode

	// Category options for filter
	const categoryOptions = useMemo(() => {
		if (!Array.isArray(allProducts)) return [];
		const cats = new Map();
		allProducts.forEach((p) => {
			if (p.categoryId && p.categoryName) {
				cats.set(p.categoryId, p.categoryName);
			}
		});

		return Array.from(cats.entries())
			.map(([id, name]) => ({ label: name, value: id }))
			.sort((a, b) => a.label.localeCompare(b.label));
	}, [allProducts]);

	return (
		<div className='flex flex-col px-4 pt-2 w-full overflow-x-auto'>
			<div className='flex items-center gap-2 sticky top-0 z-10 left-0'>
				<Store strokeWidth={1.5} />
				<h2 className='text-md font-bold'>Store Level View</h2>
				<SelectPicker
					data={categoryOptions}
					value={selectedCategory}
					onChange={setSelectedCategory}
					placeholder='Select Category'
					style={{ width: 224 }}
				/>
			</div>

			<div className='flex gap-4 min-w-full pb-4'>
				<div className='flex flex-col gap-2 sticky left-0 z-10'>
					{/* <Tooltip title='Go to Production Analysis'> */}
					<div
						// onClick={() =>
						// 	window.open(
						// 		`${urls.EXTENSION}${
						// 			urls.PRODUCTION_ANALYSIS
						// 		}?tab=geographyWise&timeFilter=store&dateRangeFilter=${encodeURIComponent(
						// 			JSON.stringify({
						// 				from: selectedDate,
						// 				to: selectedDate,
						// 			})
						// 		)}`,
						// 		'_blank'
						// 	)
						// }
						className='w-10 h-10 bg-gray-200 rounded-lg flex items-center justify-center cursor-pointer shadow-md transition-colors'
					>
						<BarChart3 size={20} className='text-yellow-900' />
					</div>
					{/* </Tooltip>
					<Tooltip title='Go to Inventory Analysis'> */}
					<div
						// onClick={() =>
						// 	window.open(
						// 		`${urls.EXTENSION}${urls.INV_ANALYSIS}`,
						// 		'_blank'
						// 	)
						// }
						className='w-10 h-10 bg-gray-200 rounded-lg flex items-center justify-center cursor-pointer shadow-md transition-colors'
					>
						<img
							src={inventoryAnalysisIcon}
							className='h-4 w-4 scale-150'
						/>
					</div>
					{/* </Tooltip> */}
					{/* <Tooltip title='Go to Operations Summary (Beta)'> */}
					<div
						// onClick={() =>
						// 	window.open(
						// 		`${urls.EXTENSION}${
						// 			urls.AIFMS_SUMMARY_DYNAMIC
						// 		}?tab=geographyWise&timeFilter=store&dateRange=${encodeURIComponent(
						// 			JSON.stringify({
						// 				from: selectedDate,
						// 				to: selectedDate,
						// 			})
						// 		)}`,
						// 		'_blank'
						// 	)
						// }
						className='w-10 h-10 bg-gray-200 rounded-lg flex items-center justify-center cursor-pointer shadow-md transition-colors'
					>
						<Table size={20} className='text-yellow-900' />
					</div>
					{/* </Tooltip> */}
				</div>
				<div className='min-w-[220px] bg-blue-50 rounded-lg p-2 flex flex-col gap-2'>
					<div className='p-2 border-b border-blue-200 mb-2 flex items-center gap-3'>
						<Warehouse size={30} strokeWidth={1.5} />
						<div>
							<h3 className='font-semibold text-base'>
								Store Inventory
							</h3>
							{/* <p className='text-xs text-gray-500'>Retail</p> */}
						</div>
					</div>

					<div className='flex flex-col gap-1 p-1 max-h-[70vh] overflow-y-auto custom-scrollbar'>
						{stockRx['store']?.map((item, idx) => (
							<StoreStockCard
								key={`${item.id}-${idx}-store`}
								item={item}
							/>
						))}
						{(!stockRx['store'] ||
							stockRx['store'].length === 0) && (
								<div className='text-center p-4 text-gray-400 text-sm'>
									No Items in Store Inventory
								</div>
							)}
					</div>
				</div>
				{assetsList.map((asset) => (
					<div
						key={asset.id}
						className='min-w-[220px] bg-blue-50 rounded-lg p-2 flex flex-col gap-2'
					>
						<div className='p-2 border-b border-blue-200 mb-2'>
							<h3 className='font-semibold text-base'>
								{asset.name}
							</h3>
							<p className='text-xs text-gray-500'>
								{asset.type}
							</p>
						</div>

						<div className='flex flex-col gap-1 p-1 max-h-[70vh] overflow-y-auto custom-scrollbar'>
							{stockRx[asset.id]?.map((item, idx) => (
								<StoreStockCard
									key={`${item.id}-${idx}-${asset.id}`}
									item={item}
								/>
							))}
							{(!stockRx[asset.id] ||
								stockRx[asset.id].length === 0) && (
									<div className='text-center p-4 text-gray-400 text-sm'>
										No Items Placed in this asset
									</div>
								)}
						</div>
					</div>
				))}
			</div>
		</div>
	);
};

export default DisplayStoreView;
